<template>
  <div class="detail_shipper_box">
    <div class="mode_box">
      <div class="card_info">托运人信息</div>
      <el-form
        ref="form"
        class="form_all_box"
        :model="form"
        label-width="160px"
        :disabled="true"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="form.staffType == 1 ? '联系人' : '托运人姓名'"
              prop="userName"
            >
              <el-input v-model="form.userName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人手机号" prop="phone">
              <el-input v-model="form.phone" autocomplete="off" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人身份证号" prop="contactsIdnum">
              <el-input
                v-model="form.contactsIdnum"
                autocomplete="off"
                placeholder="请输入联系人身份证号"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平台服务经理手机号码" prop="salesmanPhone">
              <el-input
                v-model="form.salesmanPhone"
                autocomplete="off"
                placeholder="请输入平台服务经理手机号码"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item
              label="联系人身份证有效期"
              prop="contactsIdnumValidity"
            >
              <el-date-picker
                v-model="form.contactsIdnumValidity"
                :class="form.hasDueDateContacts ? 'disabledhide' : ''"
                type="date"
                placeholder="身份证有效期"
                value-format="yyyy-MM-dd"
                clearable
                :disabled="form.hasDueDateContacts"
              />
              <!-- <el-input
                v-model="form.phone"
                autocomplete="off"
                placeholder="请选择身份证有效期"
                clearable
              /> -->
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="长期" label-width="60px">
              <el-checkbox
                v-model="form.hasDueDateContacts"
                @change="
                  value => {
                    this.$set(
                      form,
                      'contactsIdnumValidity',
                      value ? '9999-12-31' : ''
                    );
                  }
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="passwd">
              <el-input
                v-model="form.passwd"
                type="password"
                autocomplete="new-password"
                disabled
              />
            </el-form-item>
          </el-col>

          <el-col v-if="form.staffType == 1" :span="12">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="form.companyName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="住所" prop="address">
              <el-input v-model="form.address" prop="address" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="所属主管税务机关"
              prop="myTaxOrgan"
              label-width="160px"
            >
              <el-input v-model="form.myTaxOrgan" disabled />
            </el-form-item>
          </el-col>

          <el-col v-if="form.staffType == 1" :span="12">
            <el-form-item
              label="统一社会信用代码"
              prop="businessLicenseImgNumber"
            >
              <el-input v-model="form.businessLicenseImgNumber" disabled />
            </el-form-item>
          </el-col>
          <el-col v-if="form.staffType == 1" :span="12">
            <el-form-item label="法人代表名称" prop="legalName">
              <el-input v-model="form.legalName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="法人身份证号" prop="identificationNumber">
              <el-input v-model="form.identificationNumber" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="身份证有效期" prop="idCardDueDate">
              <el-date-picker
                v-model="form.idCardDueDate"
                :class="form.hasDueDate ? 'disabledhide' : ''"
                type="date"
                placeholder="请选择身份证有效期"
                value-format="yyyy-MM-dd"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="长期" label-width="60px">
              <el-checkbox
                v-model="form.hasDueDate"
                disabled
                @change="
                  value => {
                    this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                  }
                "
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col v-if="hasTaxOpen" :span="12">
            <el-form-item
              label="所属主管税务机关"
              prop="myTaxOrgan"
              label-width="160px"
            >
              <el-input v-model="form.myTaxOrgan" disabled />
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <!-- 加入所属主管税务机关 -->
          <el-col :span="12">
            <el-form-item label="简称码" prop="prefix">
              <el-input v-model="form.prefix" disabled />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="服务费率(%)" prop="taxPoint">
              <el-input
                v-model.number="form.taxPoint"
                placeholder="请输入服务费比例"
                disabled
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="通信地址" prop="areaList">
              <el-cascader
                v-model="form.areaList"
                :options="parentData.areaOptions"
                :props="{
                  value: 'countyCode',
                  label: 'countyName',
                  children: 'children'
                }"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row />

        <el-row>
          <el-col :span="24">
            <el-form-item label="上传证件">
              <ImgUpload
                :upload-config="{
                  lebal: '联系人身份证人像面照片',
                  prefix: 'contactsIdentification',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="false"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '联系人身份证国徽面照片',
                  prefix: 'contactsIdentificationBack',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="false"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '法人身份证人像面照片',
                  prefix: 'identification',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="false"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '法人身份证国徽面照片',
                  prefix: 'identificationBack',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="false"
              />
              <!-- <ImgUpload
              :upload-config="{ lebal: '手持身份证合照', prefix: 'identificationInhand', form: form, suffix: 'Img' }"
              :parent-data="parentData"
              :required="false"
            /> -->
              <ImgUpload
                v-if="form.staffType == 1"
                :upload-config="{
                  lebal: '统一社会信用三证合一照片',
                  prefix: 'businessLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="false"
              />
              <div>
                <ImgUpload
                  :upload-config="{
                    lebal: '补充材料1',
                    prefix: 'supplementaryMaterials1',
                    form: form,
                    suffix: 'Img',
                    modal: false
                  }"
                  :parent-data="parentData"
                  :required="false"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '补充材料2',
                    prefix: 'supplementaryMaterials2',
                    form: form,
                    suffix: 'Img',
                    modal: false
                  }"
                  :parent-data="parentData"
                  :required="false"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '补充材料3',
                    prefix: 'supplementaryMaterials3',
                    form: form,
                    suffix: 'Img',
                    modal: false
                  }"
                  :parent-data="parentData"
                  :required="false"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="line-height: 36px;">
          <el-col :span="20" :offset="2">
            <div style="padding-bottom: 22px;">
              <el-checkbox
                v-model="form.isMonthlyClient"
                label="是否为月结客户"
                :checked="!!form.isMonthlyClient"
                :false-label="0"
                :true-label="1"
                disabled
              />
              <!-- <el-checkbox
              v-if="isCtms"
              v-model="form.isIndependentCheckout"
              label="是否独立核算"
              :checked="!!form.isIndependentCheckout"
              :false-label="0"
              :true-label="1"
              disabled
            /> -->
              <el-checkbox
                v-if="isCtms"
                v-model="form.isEnsure"
                label="是否需要发货保证金"
                :checked="!!form.isEnsure"
                :false-label="0"
                :true-label="1"
                disabled
              />
            </div>
          </el-col>
          <!-- <el-col v-if="form.isEnsure" :span="4">
                    <el-form-item prop="ensureFee">
                        <el-input v-model="form.ensureFee" placeholder="请输入保证金"  />
                    </el-form-item>
                </el-col> -->
        </el-row>
        <el-row v-if="form.isEnsure">
          <el-col :span="8">
            <el-form-item prop="ensureFee" label="发货保证金">
              <el-input
                v-model="form.ensureFee"
                placeholder="请输入保证金"
                disabled
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="mode_box">
      <div class="card_info">承运主体信息</div>
      <el-form
        ref="formData"
        class="form_all_box"
        :model="form"
        :rules="rules"
        label-width="180px"
      >
        <!-- <el-form-item label="简称码" prop="prefix">
        <el-input v-model="prefix" />
      </el-form-item> -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="承运主体" prop="branchCode1">
              <el-select
                v-model="form.branchCode1"
                placeholder="请选择承运主体"
                :disabled="true"
                @change="handleBranchChange"
              >
                <el-option
                  v-for="item in partyGroupOptions"
                  :key="item.code"
                  :label="item.groupName"
                  :value="item.code"
                />
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="服务费率(%)" prop="taxPoint">
              <el-input
                v-model="form.taxPoint"
                :disabled="true"
                type="number"
                min="0"
                max="100"
                placeholder="请输入服务费（%）"
              /> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
    </div>
    <!-- <el-button type="primary" plain @click="funcSubmit('form')">提交</el-button> -->
  </div>
</template>
<script>
import { getShipperInfo } from "@/api/shipment";
import ImgUpload from "@/components/ImgUpload";
import { getRole } from "@/utils/getRole";
import request from "@/utils/request";
export default {
  name: "ShipperDetail",
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          goodsTypeList: [],
          typeOptions: [],
          vehicleDictList: [],
          bankOptions: []
        };
      }
    },
    mode: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      partyGroupOptions: [],
      isCtms: true, //默认显示  同城系统隐藏
      dialogVisible: false,
      hasTaxOpen: false, //是否开启税务
      dialogImageUrl: "",
      form: {
        branchCode1: "",
        staffType: "0", // 类型（托运人）
        userName: "",
        phone: "",
        passwd: "",
        identificationNumber: "",
        idCardDueDate: "",
        companyName: "",
        businessLicenseImgNumber: "", // 信用代码
        prefix: "",
        taxPoint: "",
        areaList: [],
        address: "",
        identificationImg: "",
        identificationBackImg: "",
        identificationInhandImg: "",
        businessLicenseImg: "",
        isIndependentCheckout: 0,
        isMonthlyClient: 0,
        isEnsure: 0,
        ensureFee: 0
      }
    };
  },
  computed: {
    isCompanyMode() {
      return this.mode === "company";
    }
  },
  created() {
    let isCtmsShow = getRole(); //获取登录用户登录的是否是同城系统
    this.getBranchList();
    this.isCtms = !isCtmsShow;
  },
  methods: {
    getBranchList() {
      request({
        url: "/ntocc-basic-api/partyGroup",
        method: "get"
      }).then(res => {
        if (res.status === 0) {
          console.log(this.partyGroupOptions);
          this.partyGroupOptions = res.data.records;
        }
      });
    },
    // 获取承运商详情
    getShipperDetail(code) {
      var branchCode = code.branchCode;
      request({
        url: `/ntocc-basic-api/industry/isOpen?branchCode=` + branchCode,
        method: "get"
      }).then(response => {
        this.hasTaxOpen = response.data == "1" ? true : false;
      });
      getShipperInfo(code.code).then(response => {
        this.form = response.data;
        if (response.data.branchCode) {
          this.form.branchCode1 = response.data.branchCode;
        }
        if (response.data.taxPoint) {
          this.form.taxPoint = response.data.taxPoint;
        }
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
      });
    }
  }
};
</script>
<style scoped lang="scss">
.form_all_box {
  padding-left: 20px;
  padding-right: 20px;
}
.mode_box {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #f0f3f8;
  overflow: hidden;
  margin-bottom: 18px;
  .card_info {
    width: 100%;
    height: 62px;
    line-height: 62px;
    background: #f0f3f8;
    border-radius: 0px 0px 0px 0px;
    font-weight: bold;
    font-size: 18px;
    color: #1169e9;
    padding-left: 15px;
    margin-bottom: 43px;
  }
}
.detail_shipper_box {
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 30px;
  padding-bottom: 50px;
}
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  margin-right: 20px;
}
.avatar-uploader ::v-deep.el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  box-sizing: border-box;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #c0ccda;
}
.avatar-uploader-icon:hover {
  border-color: #409eff;
}
.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
.el-cascader {
  width: 100%;
}
</style>
